const { handleError, handleResponse, api} = require("./baseApi");
const api_config = require("./api_config");

const BASE_URL = "/cms/v1";

function getActiveThemeForMerchantApi(merchantCode) {
    return api.get(`${BASE_URL}/themes/active`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            },
            params: {merchantCode}
        })
        .then(handleResponse)
        .catch(handleError);
}

function getTransactionDetailsComponent(merchantCode) {
    return api.get(`${BASE_URL}/components/transaction-details`, {
        headers: {
            "x-api-key": `${api_config.carbon_app_api_key}`
        },
        params: {merchantCode}
    })
        .then(handleResponse)
        .catch(handleError);
}

function getPurchaseConfirmationEmailComponent(merchantCode) {
    return api.get(`${BASE_URL}/components/purchase-confirmation-email`, {
        headers: {
            "x-api-key": `${api_config.carbon_app_api_key}`
        },
        params: {merchantCode}
    })
        .then(handleResponse)
        .catch(handleError);
}

module.exports = {
    getActiveThemeForMerchantApi,
    getTransactionDetailsComponent,
    getPurchaseConfirmationEmailComponent,
};
